import { faArrowsUpDownLeftRight, faExpand, faHand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToolTip from "../../../../shared/components/ToolTip/ToolTip";
import "./CameraControls.css";

const ControlButton = ({ title, active, onClick, icon, className }) => (
  <ToolTip title={title}>
    <div className={`camera-control ${active ? "active" : ""}`}>
      <button type="button" className={className} onClick={onClick}>
        <FontAwesomeIcon icon={icon} />
      </button>
    </div>
  </ToolTip>
);

const CameraControls = ({ actionControls, onResetCameraView, onPan, onMove, onSelect, isWareHouseInventoryRoute, isSELocationHighlightRoute }) => {
  return (
    <div className="camera-controls">
      <div className="camera-controls-inner">
        {/* <ControlButton title="Select" active={actionControls.select} onClick={onSelect} icon={faArrowPointer} className="select" /> */}

        <ControlButton title="Pan" active={actionControls.pan} onClick={onPan} icon={faHand} className="pan" />

        {!isWareHouseInventoryRoute && !isSELocationHighlightRoute && (
          <ControlButton title="Move" active={actionControls.move} onClick={onMove} icon={faArrowsUpDownLeftRight} className="move" />
        )}

        <ControlButton title="Reset view" onClick={onResetCameraView} icon={faExpand} className="resetView" />
      </div>
    </div>
  );
};

export default CameraControls;
